import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { RootState } from '../../../reducers';
import { getAmplitudeDefaultEventProperties } from '../../../tracking/amplitudeEvents';
import messages from '../TradingHistory.messages';
import styles from '../TradingHistory.module.css';
import {
    getIsFileUploading,
    hasDocumentUploadedButStillRequired
} from '../TradingHistory.selectors';

const mapDispatchToProps = {
    handleSubmitDocs: () => ({
        type: 'HANDLE_TRADING_HISTORY_DOC_SUBMIT'
    })
};

const mapStateToProps = (state: RootState) => ({
    isLoadingApplicationOffers: state.tradingHistory.loading,
    isFileUploading: getIsFileUploading(state),
    areUploadedDocsStillRequired: hasDocumentUploadedButStillRequired(state)
});

type SubmitCTAProps = {
    isLoadingApplicationOffers: boolean;
    handleSubmitDocs: () => void;
    isFileUploading: boolean;
    areUploadedDocsStillRequired: boolean;
};

const SubmitCTA = ({
    isLoadingApplicationOffers,
    handleSubmitDocs,
    isFileUploading,
    areUploadedDocsStillRequired
}: SubmitCTAProps) => {
    const submitLastStep = () => {
        tracking.ampli.tradingHistorySubmitted({
            'Page version': 'v2',
            ...getAmplitudeDefaultEventProperties()
        });
        handleSubmitDocs();
    };

    return (
        <div className={styles.CTAContainer}>
            <div className={styles.submitText}>
                <FormattedMessage {...messages.nearlyThere} />
            </div>

            <Button
                loading={
                    isLoadingApplicationOffers ||
                    isFileUploading ||
                    areUploadedDocsStillRequired
                }
                variant="primary"
                size="large"
                onClick={() => submitLastStep()}>
                <FormattedMessage {...messages.submitCTA} />
            </Button>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitCTA);
